__turbopack_context__.v({
  "badge-img": "_Zok7a_badge-img",
  "button-link": "_Zok7a_button-link",
  "card": "_Zok7a_card",
  "container": "_Zok7a_container",
  "contianer-img": "_Zok7a_contianer-img",
});
